Namespace 'Monitoring.Reports.Publications.Subsections'
class Monitoring.Reports.Publications.Subsections.CustomSections extends  Backbone.Model
  
  initialize:(@options, @header)->

  fetchData:() ->
    content = @options.contents[0]
    content_type = content.type
    rankings_config = @header.rankings_config()
    document_ids = []
    _.each(@options.contents, (content) ->  document_ids.push(content.id))

    content_ids = []
    _.each(@options.contents, (content) ->  content_ids.push(content.content_id))    

    params =
      date_since:  @header.getDateFrom()
      date_until: @header.getDateTo()
      dimension:  @header.getDimension()
      document_ids: document_ids
      content_ids: content_ids
      type: 'facebook'

    $.ajax
      type: 'post'
      url: '/monitoring/reports/publications/sentiment'
      data: params
      success: @resultados()
      error: @fail
      complete: @completed

  resultados:(data)=>

  fail:(data)=>

  completed:(data)=>
    complaints = new Monitoring.Reports.Publications.Subsections.ComplaintsReport(data.responseJSON.reclamo)
    @trigger('complaintsFetched', complaints)
    thematics = new Monitoring.Reports.Publications.Subsections.ThematicsReport(data.responseJSON.tematica)
    @trigger('thematicsFetched', thematics)


